var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#e01e2c;}.cls-4{fill:#0554a3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag-us") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.51V24.69c10.67-7.86,21.33,7.52,32-.34V7.84C21.33,15.48,10.67-.13,0,7.51Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-2",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,18c-10.67,7.78-21.33-7.69-32,.08V16.76c10.67-7.76,21.33,7.73,32,0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-3",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,20.54c-10.67,7.81-21.33-7.63-32,.18V19.4c10.67-7.79,21.33,7.67,32-.13Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-4",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,23.08c-10.67,7.85-21.33-7.55-32,.29V22c10.67-7.82,21.33,7.6,32-.23Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-5",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.8,7.83c6.4,2.1,12.8,5.88,19.2,1.29v1.27c-6.4,4.6-12.8.83-19.2-1.26Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-6",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.8,10.43c6.4,2.08,12.8,5.84,19.2,1.22v1.28c-6.4,4.62-12.8.87-19.2-1.2Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-7",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.8,13c6.4,2.06,12.8,5.8,19.2,1.16v1.27c-6.4,4.65-12.8.92-19.2-1.13Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-8",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,23.08v1.27c-10.67,7.86-21.33-7.52-32,.34V23.37C10.67,15.53,21.33,30.92,32,23.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,20.54v1.27c-10.67,7.83-21.33-7.59-32,.24V20.73C10.67,12.91,21.33,28.35,32,20.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,18v1.27c-10.67,7.8-21.33-7.66-32,.13V18.08C10.67,10.31,21.33,25.78,32,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,15.46v1.28c-6.4,4.65-12.8.93-19.2-1.11v-1.3C19.2,16.38,25.6,20.11,32,15.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,12.93V14.2c-6.4,4.63-12.8.89-19.2-1.17v-1.3C19.2,13.8,25.6,17.55,32,12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,10.39v1.27c-6.4,4.61-12.8.86-19.2-1.23V9.13C19.2,11.22,25.6,15,32,10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,7.84V9.12c-6.4,4.59-12.8.81-19.2-1.29V6.53C19.2,8.64,25.6,12.43,32,7.84Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-9",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.8,6.53v9.1a30.73,30.73,0,0,0-3-.79l.1-.47L9.79,14l.31-.16-.38-.08-.12-.39-.11.35-.38-.07-.27-.37-.12-.38L9,12.71l.27-.28.3-.17.31.29-.12-.39L10.1,12l.26-.27.31-.15.3.3c0-.13-.07-.26-.11-.39l.3-.15.27-.25.3-.14.31.31-.12-.39.3-.13-.37-.11-.12-.4-.12.33-.37-.11-.27-.4-.12-.39.3-.14-.37-.1L10.66,9c0,.12-.07.23-.11.34l-.38-.1L9.9,8.88c0-.12-.07-.25-.12-.38l.31-.16-.38-.08c0-.13-.07-.26-.11-.39l-.12.34L9.1,8.14l-.26-.37-.12-.38L9,7.21l.27-.28.31-.17.3.29c0-.13-.07-.26-.12-.39l.31-.15-.38-.09c0-.12-.07-.25-.11-.38l.07-.38A28.11,28.11,0,0,1,12.8,6.53Zm-.88.69.31-.13L11.85,7c0-.14-.07-.26-.12-.4,0,.11-.07.22-.11.33l-.38-.11.3.31c0,.11-.07.22-.11.33l.3-.13.31.31Zm0,1.82.31-.13-.38-.11c0-.13-.07-.26-.12-.4,0,.11-.07.22-.11.33l-.38-.11.3.31c0,.11-.07.22-.11.33l.3-.13.31.31Zm0,3.65.31-.13-.38-.11c0-.14-.07-.27-.12-.4,0,.11-.07.22-.11.33l-.38-.11.3.31-.11.33.3-.14.31.31Zm0,1.82.31-.13-.38-.11c0-.13-.07-.26-.12-.39,0,.11-.07.21-.11.32l-.38-.1.3.31-.11.33.3-.14.31.31ZM10.86,7.83l.3-.14-.38-.1c0-.13-.07-.26-.11-.39l-.12.33-.38-.09.31.3-.12.33.31-.15.3.31C10.93,8.09,10.89,8,10.86,7.83Zm0,5.48.3-.14-.38-.1c0-.13-.07-.26-.11-.39l-.12.34-.38-.09.31.29-.12.34.31-.15.3.3C10.93,13.57,10.89,13.44,10.86,13.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.23,7.09l-.31.13.12.4-.31-.32-.3.14c0-.11.08-.22.11-.33l-.3-.31.38.11c0-.11.08-.22.11-.33l.12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.23,8.91l-.31.14.12.39-.31-.31-.3.13c0-.11.08-.22.11-.33l-.3-.31.38.11c0-.11.08-.22.11-.33l.12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.23,10.74l-.31.13.12.39L11.73,11l-.3.14.11-.33-.3-.31.38.11c0-.11.08-.22.11-.33l.12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.23,12.56l-.31.13.12.39-.31-.31-.3.14.11-.33-.3-.31.38.11c0-.11.08-.22.11-.33l.12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.23,14.38l-.31.13.12.4-.31-.31-.3.13.11-.32-.3-.31.38.1c0-.11.08-.22.11-.33l.12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.24,10.45l.3.31-.11.33-.27.25-.38-.09a3.64,3.64,0,0,0-.11-.39l-.12.33-.38-.09.31.29-.12.34L10.1,12l-.38-.08-.12-.38-.11.34-.38-.07-.27-.37-.12-.38L9,10.88l-.38-.05-.12-.38c0,.11-.07.23-.11.35L8,10.75l-.27-.35c0-.13-.07-.25-.12-.37L8,9.83l-.38,0c0-.13-.07-.25-.11-.37l-.12.35H7L6.7,9.43c0-.12-.07-.24-.11-.36l.3-.22H6.52c0-.12-.08-.25-.12-.36l-.12.36-.37,0-.27-.31-.12-.35L5.83,8l.27-.35.3-.23.3.22L7,7.93l.31.24-.12.36c.1-.08.21-.14.31-.21l.3.24c0-.12-.07-.24-.12-.37L8,8l.27-.31.3-.18a3.74,3.74,0,0,1,.31.27l.27.37.3.28c0,.11-.08.22-.11.34l.3-.17.31.28.26.39.31.3-.12.33.31-.15c.1.1.2.21.3.3Zm-1.45-.12.31-.16-.38-.08L9.6,9.7c0,.12-.08.23-.11.34L9.11,10l.3.28c0,.11-.08.23-.11.34l.3-.17.31.29C9.86,10.58,9.83,10.45,9.79,10.33ZM8.72,9.23c.1-.07.21-.12.31-.18L8.65,9l-.12-.38L8.42,9,8,8.92l.31.26-.12.34.3-.18.31.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.16,7.69l-.3.14c0,.13.07.26.11.4l-.3-.31-.31.15.12-.33-.31-.3.38.09.12-.33c0,.13.07.26.11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.16,9.52l-.3.14c0,.13.07.26.11.39l-.3-.3-.31.15.12-.33-.31-.3.38.09L10.67,9c0,.13.07.26.11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.16,11.34l-.3.14c0,.14.07.27.11.4l-.3-.3-.31.15.12-.34-.31-.29.38.09.12-.33c0,.13.07.26.11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.16,13.17l-.3.14c0,.13.07.26.11.39l-.3-.3-.31.15.12-.33-.31-.29.38.08.12-.33c0,.13.07.26.11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.09,6.52l-.31.15.12.39-.3-.29-.31.17.12-.34L9.1,6.32l.38.07.12-.34c0,.13.08.25.11.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.09,8.34l-.31.16.12.38L9.6,8.6l-.31.17.12-.34L9.1,8.15l.38.07.12-.34c0,.13.08.26.11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.09,10.17l-.31.16.12.38-.3-.28-.31.16.12-.34L9.1,10l.38.06.12-.33c0,.12.08.25.11.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.09,12l-.31.16.12.39-.3-.28-.31.16.12-.34-.31-.27c.13,0,.25,0,.38.06l.12-.34c0,.13.08.26.11.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.09,13.82,9.78,14l.12.39-.3-.29-.31.17.12-.34-.31-.28.38.07.12-.34c0,.13.08.25.11.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.91,14.37l-.1.47A12.68,12.68,0,0,0,3.6,15l-.1-.47-.11-.33.3-.31L4,13.44l.31-.3.3.16.27.29.3.18c0,.12-.07.25-.12.37l.31-.26a3,3,0,0,1,.3.19,3.58,3.58,0,0,0-.11-.35l.3-.26.27-.35.31-.23.3.22a3,3,0,0,0-.12-.36l.31-.23H6.51c0-.12-.07-.24-.11-.36l-.12.37-.38,0-.27-.31a3.58,3.58,0,0,0-.11-.35l.3-.25.27-.35.31-.23.3.21L7,11.6l.31.23-.12.36L7.47,12l.3.24.27.35.3.26a3.58,3.58,0,0,1-.11.35l.3-.19.31.27.26.37.31.28-.12.34.31-.17Zm-2.26-.68a3.28,3.28,0,0,0,.31-.2l-.38,0c0-.13-.07-.25-.11-.37l-.12.35H7l.31.23L7.16,14l.31-.21.3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.67,5.67l-.07.38-.11.34-.38-.07.3.28c0,.11-.08.22-.11.34L9,7.22l-.38-.06-.12-.38c0,.12-.07.24-.11.35L8,7.09l.31.26-.12.35L8,8,7.58,8c0-.13-.07-.25-.11-.37L7.35,8H7L6.7,7.61c0-.13-.07-.25-.11-.37L6.89,7H6.52L6.4,6.66,6.28,7a2.3,2.3,0,0,0-.37,0l-.27-.32-.12-.35.31-.25-.38,0-.12-.35,0-.39A14.06,14.06,0,0,1,9.67,5.67Zm-2,.69A3.28,3.28,0,0,0,8,6.16l-.38,0c0-.13-.07-.25-.11-.37l-.12.35H7l.31.23-.12.36.31-.21.3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.41,12.08l-.12.34L9,12.71l-.37-.06-.12-.38-.12.35-.37,0-.27-.35-.12-.37.31-.2-.38,0c0-.13-.08-.25-.11-.37l-.12.35H7l-.27-.33c0-.12-.07-.24-.12-.36l.31-.23H6.51c0-.12-.07-.24-.11-.36l-.12.37-.38,0-.27-.31a3.58,3.58,0,0,0-.11-.35l.3-.25.27-.35.31-.24.3.23L7,9.77a3.55,3.55,0,0,0,.31.23c0,.13-.08.24-.12.36a3.28,3.28,0,0,1,.31-.2l.3.24.27.35.3.26a3.58,3.58,0,0,1-.11.35l.3-.19.31.27.26.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,7.22l-.31.18.12.38a3.74,3.74,0,0,0-.31-.27l-.3.18.12-.35L8,7.08l.38,0,.11-.35.12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,9.05a2.48,2.48,0,0,0-.31.18l.12.37-.31-.26-.3.18.12-.34L8,8.92l.38,0c0-.11.07-.23.11-.35L8.65,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,10.88l-.31.18.12.37-.31-.26-.3.19L8.35,11,8,10.75l.38,0c0-.11.07-.23.11-.35l.12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9,12.71l-.31.17.12.38L8.53,13l-.3.18.12-.35L8,12.58l.38,0c0-.11.07-.23.11-.35l.12.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,8l-.31.19.12.37-.3-.24-.31.21.12-.36L7,7.93l.38,0,.12-.36c0,.13.07.25.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,9.83l-.31.2.12.37-.3-.24-.31.2c0-.12.08-.23.12-.36L7,9.77l.38,0,.12-.36c0,.12.07.25.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,11.66l-.31.2.12.37L7.47,12l-.31.21.12-.36A3.55,3.55,0,0,0,7,11.61h.38l.12-.36c0,.12.07.25.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,13.49l-.31.2.12.37-.3-.24L7.16,14l.12-.36L7,13.44h.38l.12-.35c0,.12.07.24.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,6.16a3.28,3.28,0,0,1-.31.2l.12.38-.3-.25-.31.21.12-.36A3.55,3.55,0,0,0,7,6.11h.38l.12-.35c0,.12.07.24.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.89,7l-.3.22c0,.12.08.24.11.37l-.3-.23-.3.24c0-.12.07-.25.11-.37L5.91,7l.37,0,.12-.36L6.52,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.89,8.85l-.3.22c0,.12.08.25.11.37l-.3-.23-.3.24c0-.12.07-.25.11-.37l-.3-.21.37,0,.12-.36.12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.89,10.69l-.3.22c0,.12.08.24.11.36l-.3-.22-.3.24c0-.12.07-.25.11-.37l-.3-.21.37,0,.12-.36q.06.16.12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.52,12.52h.37l-.3.22c0,.13.08.25.11.36l-.3-.22-.3.24c0-.12.07-.24.11-.36l-.3-.21.37,0,.12-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.21,7.25l-.12.36L5.82,8,5.44,8l-.11-.36c0,.13-.07.25-.12.38l-.37.05.3.19c0,.12-.07.25-.12.37l.31-.26.3.2.27.31c.1.07.21.13.31.21l-.12.36-.27.35-.38,0-.11-.35c0,.13-.07.25-.12.38l-.37.05-.27-.28-.12-.34L4.76,9l-.38.07c0-.11-.07-.23-.11-.34l-.12.39-.37.1L3.51,9l-.12-.33.31-.32-.38.11L3.2,8.11c0,.13-.07.27-.11.4l-.38.14-.27-.23L2.33,8.1l.3-.34-.37.15L2.14,7.6c0,.14-.07.28-.12.41l-.37.19L1.38,8l-.12-.3.31-.39-.38.2c0-.09-.07-.2-.12-.29L.63,7.09A10.7,10.7,0,0,1,5.3,5.42l0,.38-.11.38-.38.06c.1,0,.2.12.3.18s-.07.25-.11.38l.3-.27.31.2L5.91,7C6,7.11,6.11,7.17,6.21,7.25Zm-1.76.2.31-.28-.38.06c0-.11-.07-.22-.11-.33l-.12.39a2.49,2.49,0,0,0-.37.09l.3.15L4,7.92l.31-.3.3.17ZM3.39,6.79l.3-.31-.38.11c0-.11-.08-.22-.11-.33l-.12.4L2.7,6.8,3,6.91l-.12.4L3.2,7l.3.14C3.47,7,3.42,6.9,3.39,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.21,10.92l-.12.37-.27.35-.38,0-.11-.35c0,.12-.07.25-.12.38l-.37.05.3.18c0,.13-.07.25-.12.38L5.33,12l.3.2.27.31c.1.07.21.13.31.21l-.12.36-.27.35-.38,0c0-.11-.07-.23-.11-.34,0,.12-.07.25-.12.37l-.37.06-.27-.28L4.45,13l.31-.28-.38.07c0-.11-.07-.23-.11-.34l-.12.39-.37.1.3.14-.12.4-.27.4L3.32,14l-.12-.33-.12.41-.37.14.3.11c0,.14-.07.27-.12.4l.31-.33.3.13.1.47A11.68,11.68,0,0,0,0,16.77V7.51l.62-.42.45.13L1,7.65l-.38.24.31,0-.12.44L1.07,8l.3.06.27.19.3.08c0,.14-.07.28-.11.42l.3-.37.31.09.26.23L3,8.76l-.12.41c.1-.12.2-.22.31-.33L3.5,9l.27.26.3.15c0,.13-.07.26-.12.39l.31-.3.3.17.27.28.3.18c0,.13-.07.26-.11.38l.3-.26.31.19.26.31A2.49,2.49,0,0,1,6.21,10.92Zm-1.76.21.31-.28-.38.07c0-.11-.07-.23-.11-.34L4.15,11l-.37.09.3.15-.12.4.31-.3.3.16Zm-1.06-.65.3-.32-.38.12c0-.11-.08-.22-.11-.33l-.12.41-.38.13.31.12-.12.4.31-.33.3.13C3.47,10.7,3.42,10.59,3.39,10.48Zm0,1.84.3-.31-.38.11c0-.11-.08-.22-.11-.33l-.12.41-.38.14.31.11-.12.4.31-.33.3.13C3.47,12.54,3.42,12.43,3.39,12.32ZM2.32,10l.31-.35-.38.15c0-.1-.07-.21-.12-.31,0,.14-.07.28-.11.41L1.64,10l.3.08c0,.14-.07.28-.11.42l.3-.37.31.09Zm0,1.84.31-.35-.38.15c0-.1-.07-.2-.12-.31,0,.14-.07.28-.11.42s-.25.12-.38.18l.3.08c0,.14-.07.28-.11.42l.3-.37.31.09Zm0,1.85.31-.35c-.13,0-.25.1-.38.15s-.07-.2-.12-.31c0,.14-.07.28-.11.42l-.38.19.3.07c0,.14-.07.28-.11.42l.3-.37.31.09ZM1.26,9.55l.3-.39-.38.2c0-.1-.07-.2-.11-.3L1,9.49l-.38.23.31,0-.12.44.31-.41.3.06C1.33,9.75,1.29,9.65,1.26,9.55Zm0,1.85.3-.39-.38.2c0-.1-.07-.2-.11-.3L1,11.35l-.38.23.31,0-.12.43c.11-.13.21-.27.31-.41l.3.06C1.33,11.59,1.29,11.5,1.26,11.4Zm0,1.84.3-.39-.38.21c0-.1-.07-.2-.11-.3L1,13.19l-.38.24a1.55,1.55,0,0,1,.31,0l-.12.43c.11-.13.21-.27.31-.4l.3,0C1.33,13.44,1.29,13.34,1.26,13.24Zm0,1.85.3-.39-.38.2c0-.09-.07-.2-.11-.29L1,15l-.38.24a1.55,1.55,0,0,1,.31,0l-.12.43.31-.41.3.06C1.33,15.29,1.29,15.19,1.26,15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.83,6.13l-.31.25.12.35-.31-.2L5,6.8c0-.13.07-.26.12-.38l-.31-.18.38-.06.11-.38.12.36A2.34,2.34,0,0,1,5.83,6.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.83,9.8l-.31.25.12.35-.31-.19-.3.26c0-.13.07-.25.12-.38l-.31-.18.38-.05c0-.13.07-.26.11-.38l.12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.83,13.47l-.31.25.12.36-.31-.19-.3.26c0-.13.07-.25.12-.38l-.31-.17.38-.06.11-.38.12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.83,8l-.31.25.12.35-.31-.19L5,8.63c0-.12.07-.25.12-.38l-.31-.18L5.22,8c0-.13.07-.26.11-.38L5.45,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.83,11.64l-.31.25.12.35L5.33,12l-.3.27c0-.13.07-.25.12-.38l-.31-.18.38-.05c0-.13.07-.26.11-.38l.12.35C5.57,11.66,5.7,11.64,5.83,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.76,10.84l-.31.28.12.35-.3-.17L4,11.6l.12-.4-.3-.14.37-.1.12-.39c0,.12.07.23.11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.38,12.76l.38-.07L4.45,13l.12.34-.31-.16-.3.29c0-.13.07-.26.11-.39l-.3-.15.38-.09c0-.13.07-.26.11-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.76,7.17l-.31.28.12.34-.3-.17L4,7.92l.12-.4-.3-.15.37-.09.12-.39c0,.12.07.23.11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.76,9l-.31.28.12.34-.3-.17L4,9.76l.12-.39-.3-.15.37-.1.12-.39c0,.12.07.23.11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.69,8.32l-.3.31L3.5,9l-.3-.13-.31.33L3,8.76l-.3-.12.37-.13L3.2,8.1l.12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.69,10.16l-.3.32.11.33-.3-.13L2.89,11,3,10.6l-.3-.11.37-.14L3.2,10l.12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.69,12l-.3.31.11.33-.3-.13-.31.33.12-.4-.3-.11.37-.14.12-.41.12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.31,14l.38-.11c-.1.1-.21.2-.3.31l.11.33-.3-.13c-.11.11-.21.22-.31.34L3,14.29l-.31-.11L3.08,14l.12-.41C3.24,13.74,3.28,13.85,3.31,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.69,6.48l-.3.32.11.32L3.2,7l-.31.33L3,6.92l-.3-.12.37-.13.12-.4.12.33C3.44,6.55,3.57,6.52,3.69,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.63,9.6c-.11.11-.21.23-.31.35l.12.32-.31-.1-.3.37c0-.14.08-.28.11-.42l-.3-.07L2,9.86c0-.14.07-.28.11-.41l.12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.63,11.44l-.31.35.12.32L2.13,12l-.3.37c0-.14.08-.28.11-.42l-.3-.08L2,11.71c0-.14.07-.28.11-.42l.12.32A3.17,3.17,0,0,1,2.63,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.63,7.75l-.31.35.12.32-.31-.1-.3.37c0-.14.08-.28.11-.42l-.3-.07L2,8c0-.14.07-.28.11-.41l.12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.63,13.29c-.11.11-.21.23-.31.35l.12.31-.31-.09-.3.37c0-.14.08-.28.11-.42l-.3-.07L2,13.55c0-.14.07-.28.11-.42l.12.31C2.38,13.39,2.5,13.33,2.63,13.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.56,7.31c-.1.13-.21.26-.3.39s.07.2.11.3l-.3,0c-.11.13-.21.26-.31.4l.12-.43-.31,0L1,7.65c0-.14.07-.29.12-.43,0,.1.07.2.11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.56,9.16c-.1.13-.21.25-.3.39s.07.2.11.3l-.3-.06-.31.41.12-.43-.31,0L1,9.5c0-.15.07-.29.12-.43l.11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.56,11c-.1.13-.21.25-.3.39s.07.2.11.3l-.3-.06c-.11.13-.21.27-.31.41l.12-.44-.31,0L1,11.34c0-.14.07-.29.12-.43,0,.1.07.2.11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.56,12.85c-.1.13-.21.26-.3.39s.07.2.11.3l-.3,0c-.11.13-.21.27-.31.41l.12-.44-.31,0L1,13.19c0-.14.07-.28.12-.43,0,.1.07.2.11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.56,14.7c-.1.13-.21.26-.3.39s.07.2.11.3l-.3-.05c-.11.13-.21.27-.31.41l.12-.44-.31,0L1,15c0-.14.07-.29.12-.43,0,.1.07.2.11.3A3.59,3.59,0,0,1,1.56,14.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.67d8423f7addbe0707a2beddca2add0e.svg";
export { ForwardRef as ReactComponent };